import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import { DEFAULT_SPLIT_RATIO, SplitShare, SplitShareForm } from "./splitShareDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<SplitShare>,
  data?: SplitShare,
): SplitShareForm {
  return new SplitShareForm(dispatch, context, data);
}

export function applyForm(form: SplitShareForm): SplitShare {
  return {
    type: DecisionType.splitShare,
    ratio: form.ratio.toNumber() ?? DEFAULT_SPLIT_RATIO,
    shareCapitalParagraph: form.shareCapitalParagraph.selected,
  };
}

export function validate(form: SplitShareForm) {
  return form.validate();
}

export function isValid(form: SplitShareForm) {
  return form.isValid;
}

export const splitShareHandler: DecisionTypeHandler<
  DecisionType.splitShare,
  SplitShare,
  SplitShareForm
> = {
  type: DecisionType.splitShare,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent(form: SplitShareForm, event: DbotEvent) {
    form.handleEvent(event);
  },
};
